import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import useDimensions from "react-use-dimensions";
import classNames from "classnames";

import { colors } from "../theme";

const Container = styled.article`
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 10px;
  padding: 36px 30px;
  position: relative;
  transition: 0.3s;

  @media (max-width: 767px) {
    padding: 20px 22px;
  }

  :hover,
  &.isOpen {
    border-color: ${colors.primaryColor};

    button {
      background: ${colors.primaryColor};
      color: white;
    }
  }

  &.isOpen button {
    transform: rotate(180deg);
  }

  button {
    background: #e5e9e9;
    border-radius: 50%;
    color: #c3c9c9;
    font-size: 2.2rem;
    height: 32px;
    position: absolute;
    right: 28px;
    top: 32px;
    transition: 0.3s;
    width: 32px;

    @media (max-width: 767px) {
      top: 16px;
      right: 16px;
    }
  }

  h1 {
    color: black;
    font-size: 2rem;
    font-weight: 400;
    letter-spacing: 0.06rem;
    margin-right: 45px;
    text-transform: uppercase;
  }
`;

const Content = styled.div`
  height: 0;
  overflow: hidden;
  transition: 0.5s;

  &.isOpen {
    height: ${(props) => props.height + "px"};
  }

  > div {
    padding-top: 13px;

    @media (max-width: 767px) {
      margin-top: -10px;
    }
  }

  h2 {
    color: ${colors.textColor};
    font-size: 1.5rem;
    font-weight: 700;
    margin: 2.4rem 0;
    text-decoration: underline;
  }

  p {
    letter-spacing: -0.018rem;
    line-height: 2.4rem;
    margin-top: 2.4rem;
  }

  a {
    color: ${colors.primaryColor};
    transition: 0.3s;

    :hover {
      color: ${colors.primaryHover};
    }
  }

  ul,
  ol {
    margin: 30px 0;

    @media (max-width: 767px) {
      padding-left: 30px;
    }
  }

  li {
    margin-bottom: 15px;
  }
`;

function Dropdown({ title, children, shouldOpen }) {
  const [isOpen, setIsOpen] = useState(false);
  const [contentRef, { height }] = useDimensions();
  const className = classNames({ isOpen: isOpen });

  useEffect(() => {
    if (shouldOpen) {
      setIsOpen(shouldOpen);
    }
  }, [shouldOpen]);

  function toggleDropdown() {
    setIsOpen((state) => !state);
  }

  return (
    <Container onClick={toggleDropdown} className={className}>
      <button>
        <i className="fal fa-angle-down" />
      </button>
      <h1>{title}</h1>

      <Content className={className} height={height}>
        <div ref={contentRef}>{children}</div>
      </Content>
    </Container>
  );
}

Dropdown.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  shouldOpen: PropTypes.bool,
};

export default Dropdown;
